import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { fieldMappingSelector } from 'slices/field.slice';
import { EFieldType, type TField, type TType } from '@timeedit/types';

const EXACT_SEARCH_FIELD_TYPES: EFieldType[] = [
  EFieldType.CATEGORY,
  EFieldType.CHECKBOX,
];

const isExactSearchFieldType = (field: TField | undefined): field is TField =>
  field != null &&
  EXACT_SEARCH_FIELD_TYPES.includes(field.fieldType as EFieldType);

/**
 * Returns fields that should use exactSearch (CATEGORY and CHECKBOX types)
 * for the given object type.
 */
export function useExactSearchFields(
  objectType: string | undefined,
  availableObjectTypes: TType[]
): TField[] {
  const fieldsMap = useSelector(fieldMappingSelector);

  return useMemo(() => {
    const typeId = Number(objectType);
    if (Number.isNaN(typeId)) return [];

    const type = availableObjectTypes.find((t) => t.id === typeId);
    if (!type) return [];

    const fieldIds = type.fields.concat(type.parentFields);
    return fieldIds.map((id) => fieldsMap[id]).filter(isExactSearchFieldType);
  }, [objectType, availableObjectTypes, fieldsMap]);
}
